export default [
    {
        path: '/journal/lines-without-datev-account',
        name: 'journal_lines_without_datev_account',
        component: () => import('@src/journal/journal-lines-without-datev-account.vue'),
        meta: {
            title: 'Journalbuchungen ohne Datevkonto',
            role: 'ROLE_JOURNAL_LINES_WITHOUT_DATEV_ACCOUNT',
        },
    },
];
